import { ICatFormData } from "libs/state/src/lib/stores/signupFlow/types";

import { InputError } from "./types";

/**
 * Validates a list of cat names and returns a record of input errors
 * for indexes that are marked as "touched".
 * @param names - The names to validate
 * @param touchedIndexes - The indexes that are marked as "touched"
 * @returns A record of input errors for indexes that are marked as "touched"
 */
export const validate = (
  names: string[],
  touchedIndexes: ReadonlySet<number>,
): Record<number, InputError> => {
  const errors: Record<number, InputError> = {};
  const standardised = names.map((n) => n.trim().toLowerCase());

  standardised.forEach((name, index) => {
    if (!touchedIndexes.has(index)) { return; }

    const error: InputError = {};

    if (name === "") {
      error.isEmpty = true;
    } else {
      const duplicateIndex = standardised.findIndex(
        (n, i) => i !== index && n === name,
      );
      if (duplicateIndex !== -1) {
        error.isDuplicate = true;
      }
    }

    if (error.isEmpty || error.isDuplicate) {
      errors[index] = error;
    }
  });

  return errors;
};

/**
 * Extracts cat names from the store and returns an array of names
 * @param cats - The cats object from the store
 * @returns An array of cat names
 */
export const extractCatNamesFromStore = (cats: Record<string, ICatFormData>): string[] => {
  const names = Object.values(cats)
    .filter((cat) => !cat.softDelete)
    .map((cat) => cat.name || "");
  return names.length > 0 ? names : [ "" ];
};
